import { useEffect } from "react";
import useCopSecurityService from "services/security/useCopSecurityService";

const IDPLogin: React.FC = () => {
  const securityService = useCopSecurityService();

  const originalUrl = securityService.getOriginalUrl();
  const redirectUrl = securityService.getRedirectUrl();
  const specifiedIDP = securityService.getSpecifiedIDP();

  useEffect(() => {
    securityService.loginViaSpecifiedIDP(specifiedIDP, redirectUrl, originalUrl);
  }, []);

  return null;
};

export default IDPLogin;
